import { render, staticRenderFns } from "./bld-af.vue?vue&type=template&id=5ad572f4&scoped=true&"
import script from "./bld-af.vue?vue&type=script&lang=js&"
export * from "./bld-af.vue?vue&type=script&lang=js&"
import style0 from "./bld-af.vue?vue&type=style&index=0&id=5ad572f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad572f4",
  null
  
)

export default component.exports